module.exports = __webpack_public_path__ + "img/Martin-Saavedra.282a6903.jpg";